import { render } from "./EventBooking.vue?vue&type=template&id=6dccc777&scoped=true"
import script from "./EventBooking.vue?vue&type=script&lang=js"
export * from "./EventBooking.vue?vue&type=script&lang=js"

import "./EventBooking.vue?vue&type=style&index=0&id=6dccc777&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dccc777"]])

export default __exports__